import MarkdownIt from 'markdown-it'

/**
 * Единая точка создания MarkdownIt для всего ERP.
 *
 * Раньше семь мест (вики, вакансии, заявки, чат, AI-тексты) создавали свой
 * экземпляр с одинаковыми опциями. Пока настройки совпадали, дублирование было
 * безобидным — до первого расхождения в поведении библиотеки.
 *
 * markdown-it 15 перевёл linkify-it на v6, где fuzzyLink выключен по умолчанию:
 * «пишите на example.com» перестаёт становиться ссылкой, а «https://example.com»
 * продолжает работать. Для наших текстов, которые пишут люди и AI, это заметная
 * потеря — домен без схемы там встречается постоянно. Восстанавливаем прежнее
 * поведение явно, в одном месте, а не семью копиями настройки.
 */
export function createMarkdown(options = {}) {
    const md = new MarkdownIt({ linkify: true, breaks: true, ...options })
    // Явно, а не «по умолчанию»: в 14 это подразумевалось, в 15 — нет.
    md.linkify.set({ fuzzyLink: true })
    return md
}
